module.exports = __webpack_public_path__ + "31a1ae127cb6a2740f4791296f2f2bd5.mp3";